
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/legal-stuff",
      function () {
        return require("private-next-pages/uk/legal-stuff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/legal-stuff"])
      });
    }
  